import { render } from "./EditExpenseModal.vue?vue&type=template&id=204c778c"
import script from "./EditExpenseModal.vue?vue&type=script&lang=js"
export * from "./EditExpenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__